import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const postalCode = createAsyncThunk(
  'postalCode',
  async (cp) => {
    const getPostalCode = await axios.get(`https://0xo55otzd1.execute-api.us-east-1.amazonaws.com/step1/postal_code/show/${cp}`)
      .then((resp) => resp.data.data)
      .catch((err) => err.response.data);
    return getPostalCode;
  },
);

const cpSlice = createSlice({
  name: 'cp',
  initialState: {
    cp: [],
    statusCP: false,
    errorCP: false,
  },

  extraReducers: {
    [postalCode.pending]: (state) => {
      state.statusCP = 'loading';
    },
    [postalCode.fulfilled]: (state, action) => {
      state.statusCP = 'success';
      state.cp = action.payload;
    },
    [postalCode.rejected]: (state) => {
      state.statusCP = 'failed';
    },
  },
  reducers: {
    removeErrorCP: (state) => {
      state.errorCP = false;
    },
    setErrorCP: (state) => {
      state.errorCP = true;
    },
  },
});

export const { removeErrorCP, setErrorCP } = cpSlice.actions;
export default cpSlice.reducer;
